import React from "react";
import { Block, Button, FieldArray, FormGroup, Input, PortletAccordionItem, TextAreaInput } from "../../../../components";
import colors from "../../../../utils/colors";

export default function ListOtherCourses({ value = [] }) {
    return (
        <FieldArray
            name={"otherCourses"}
            render={(arrayHelpers) => {
                return (
                    <>
                        {value.map((_item, index) => {
                            return (
                                <PortletAccordionItem
                                    key={index}
                                    title={"Courses" + " #" + (index + 1)}
                                    onClickDelete={() => arrayHelpers.remove(index)}
                                    onClickMoveDown={() => arrayHelpers.move(index, index + 1)}
                                    onClickMoveUp={() => arrayHelpers.move(index, index - 1)}
                                >
                                    <FormGroup title="Course">
                                        <Block width={456}>
                                            <Input Component={TextAreaInput} name={`otherCourses[${index}].activities`} placeholder="Activities in the company" />
                                        </Block>
                                    </FormGroup>
                                </PortletAccordionItem>
                            );
                        })}
                        <Block>
                            <Button width="100%" icon="plus_16px" color={colors.grey01} onClick={() => arrayHelpers.insert(value.length, {})} />
                        </Block>
                    </>
                );
            }}
        />
    );
}